export const CATEGORY_FORM_DESCRIPTION_LABEL = 'Description de la page';
export const CATEGORY_FORM_PARTNER_TITLE_LABEL = 'Titre partenaire';
export const CATEGORY_FORM_SEO_DESCRIPTION_LABEL = 'Description (SEO)';
export const CATEGORY_FORM_TAG_LABEL = 'Tags associés';
export const CATEGORY_FORM_TITLE_LABEL = 'Titre de la page';
export const CATEGORY_FORM_URL_LABEL = 'Slug';
